'use client';

import {
  CUSTOMER_CREDIT_TYPES,
  getCustomerCreditBalance,
} from '@eliadmin/core/src/api/customers/customer-credit-utils';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useState } from 'react';
import { FaUnlock } from 'react-icons/fa';
import { CurriculumBuyDialog } from './curriculum-buy-dialog';

export const CurriculumDetailPurchase = ({ slug }: { slug: string }) => {
  const { t } = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const { me } = useCustomerStore();
  const curriculumBalance = getCustomerCreditBalance(
    me?.customer,
    CUSTOMER_CREDIT_TYPES.CURRICULUM_VITAES_BALANCE,
  );

  return (
    <>
      <CurriculumBuyDialog slug={slug} isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="flex w-full flex-col items-center justify-center">
        <div className="flex w-full max-w-[400px] flex-col items-center gap-4">
          <p>
            Ak chcete získať prístup k všetkým informáciam o tomto životopise, je potreba ho
            odomknúť
          </p>
          <p className="font-semibold">Ostáva {curriculumBalance} odomknutí</p>
          <Button
            className="w-full gap-2"
            onClick={() => {
              setIsOpen(true);
            }}
          >
            <FaUnlock /> {t('text2105')}
          </Button>
        </div>
      </div>
    </>
  );
};
